var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{staticClass:"column__tool__buttom",attrs:{"type":"info","size":"mini","icon":"el-icon-circle-close","plain":""},on:{"click":function($event){return _vm.DoStop()}}},[_vm._v("停用")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }